import React, { useEffect, useState } from "react";
import { Typography, Grid } from "@material-ui/core";
import logo from "assets/logo.jpg";
import axios from "axios";
import { URL_API_CONFIGURACION } from "constantes/urls";
export default function Cierre(props) {
  const [message, setMessage] = useState("");

  const getMessage = async () => {
    try {
      const response = await axios({
        method: "GET",
        url: `${URL_API_CONFIGURACION}/mensaje-cierre-portal`,
      });

      if (response) {
        if (response.status === 200) {
          setMessage(() => response?.data?.message || "");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getStatusPortal = async () => {
    try {
      const response = await axios({
        method: "GET",
        url: `${URL_API_CONFIGURACION}/estado-cierre-portal`,
      });

      if (response) {
        if (response.status === 200) {
          if (response.data.isOpen) {
            props.history.push("/");
          }
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    getMessage();
    getStatusPortal();
  }, []);
  return (
    <Grid container direction="column" justify="center" alignItems="center">
      <img src={logo} alt="Logo" style={{ marginTop: 30 }} />
      <Typography variant="h4" align="center" style={{ marginTop: 30 }}>
        {message
          ? message
          : "La radicación se debe realizar de lunes a viernes."}
      </Typography>
    </Grid>
  );
}
